export const currencyConstants = {
    GET_CURRENCIES_REQUEST: 'GET_CURRENCIES_REQUEST',
    GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
    GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',

    ID_EUR: 1
};
